export default "__VITE_ASSET__BuW8ZnBs__"